import { useCallback } from 'react'
import { signinThunk, signoutThunk } from 'react-common'
import { useAppDispatch } from '@/store/hooks'

export const useAuthThunks = () => {
  const dispatch = useAppDispatch()

  const handleLogin = useCallback(() => {
    dispatch(signinThunk())
  }, [dispatch])

  const handleLogout = useCallback(() => {
    dispatch(signoutThunk())
  }, [dispatch])

  return {
    handleLogin,
    handleLogout,
  }
}
